import template from '../../templates/companies/Main.html';
import CompanyView from './Company.js';
import PaginatedList from 'commons/views/PaginatedList.js';
import loader from 'helpers/loader';
import Alerts from 'lib/alerts';
import AddTpl from '../../templates/companies/Add.ejs';
import User from 'newModels/user.js';

module.exports = PaginatedList.extend({
    events: {
        'click .js-save': 'save',
        'input .js-email': 'onEmailChange'
    },

    views: [],

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            pagination: false
        });

        this.views = [];

        this.collection.on('sync', this.render, this);

        // 20200810 why do you need paging on mpp admin at all?
        this.collection.fetch({
            validate: false,
            filter: {
                limit: 9999
            }
        });

        this.stopLoader = loader.startFullPage(this.$('table'));

        return this;
    },

    save: function(ev) {
        const stopLoader = loader.startFullScreen(ev.currentTarget);
        const email = this.$('.js-email').val();
        const name = this.$('.js-name').val();

        User.inviteMppCustomer(name, email, app.user.id)
            .then(() => {
                stopLoader();
                this.$('#add-modal').modal('hide');
                return Alerts.show('success', {
                    title: 'MPP Customer Invitation',
                    text: 'Invitation successfully sent!'
                });
            }, err => {
                stopLoader();
                this.$('#add-modal').modal('hide');
                return Alerts.show('error', {
                    title: 'MPP Invitation not sent',
                    text: err
                });
            });
    },

    onEmailChange: function() {
        if (this.$('.js-email').val()) {
            this.$('.js-save').prop('disabled', false);
        } else {
            this.$('.js-save').prop('disabled', true);
        }
    },

    render: function() {
        let sortClass = this.collection.getSort().order === 'ascending' ?
            'footable-sorted-desc' : 'footable-sorted';

        this.$el.html(template({
            searchTerm: this.collection.getSearchTerm(),
            total: this.collection.length,
            pagination: (
                this.options.pagination && this.collection.getPaginationInfo()
            ),
            sort: this.collection.getSort(),
            addModal: AddTpl(),
            role: app.user.get('role')
        }));

        this.collection.forEach(company => {
            this.views.push(new CompanyView({model: company}));
            this.$('.js-companies').append(_(this.views).last().$el);
        });

        this.$('.footable-sortable')
            .removeClass('footable-sorted-desc')
            .removeClass('footable-sorted');

        this.$('[data-sort="' + this.collection.getSort().key + '"]')
            .addClass(sortClass);

        this.stopLoader();
        return this;
    },

    navigate() {
        app.mainRouter.navigate('companies' +
            '/' + this.collection.getSort().key +
            '/' + this.collection.getSort().order +
            (
                this.collection.getSearchTerm() ?
                '/' + this.collection.getSearchTerm() : ''
            ), {trigger: true});
    }
});



// WEBPACK FOOTER //
// ./app/mpp/views/companies/Main.js